var UIToggle = (function ($) {

    UIToggle = function () {
        var that = this;

        // CONST

        // INIT
        that.init();
    };

    UIToggle.prototype.class = {
        is_active: 'is-toggle-active',
        is_move: 'is-move',
        toggle: 'js-toggle',
        trigger: 'js-toggle-trigger',
        trigger_desktop: 'js-toggle-trigger-desktop',
        trigger_tablet: 'js-toggle-trigger-tablet',
        trigger_mobile: 'js-toggle-trigger-mobile',
        trigger_custom: 'js-toggle-trigger-custom',
        wrapper: 'js-toggle-wrapper',
        start_active: 'js-toggle-start-active',
        start_inactive: 'js-toggle-start-inactive',
        hide_ignore: 'js-toggle-ignore-hide'
    };

    UIToggle.prototype.duration = 10;

    UIToggle.prototype.init = function () {
        var that = this;

        //
        that.initEventHandlers();
    };

    UIToggle.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.' + that.class.trigger, function (e) {
            that.__triggerClick(e,$(this));
        });
        
        $.sa.$document.on('click', '.' + that.class.trigger_desktop, function (e) {
            if ($.sa.is_desktop()) {
                that.__triggerClick(e, $(this));
            }
        });
        
        $.sa.$document.on('click', '.' + that.class.trigger_tablet, function (e) {
            if ($.sa.is_tablet()) {
                that.__triggerClick(e, $(this));
            }
        });

        $.sa.$document.on('click', '.' + that.class.trigger_mobile, function (e) {
            if ($.sa.is_mobile()) {
                that.__triggerClick(e, $(this));
            }
        });

        $.sa.$document.on('click', '.' + that.class.trigger_custom, function (e) {
            var $trigger = $(this),
                width_min = 0,
                width_max = 999999,
                window_width = window.innerWidth;

            if ($trigger.data('toggle-custom-width-min')) {
                width_min = $trigger.data('toggle-custom-width-min');
            }
            if ($trigger.data('toggle-custom-width-max')) {
                width_max = $trigger.data('toggle-custom-width-max');
            }
            
            if (window_width >= width_min && window_width <= width_max) {
                that.__triggerClick(e, $(this));
            }
        });
    };

    UIToggle.prototype.__triggerClick = function (e, $trigger) {
        e.preventDefault();

        var that = this;

        that.toggleTrigger($trigger);
    };

    UIToggle.prototype.toggleTrigger = function ($trigger) {
        var that = this,
            $wrapper = $trigger.parents('.' + that.class.wrapper),
            target = $trigger.data('toggle-for');

        that.hideAll($wrapper, target);
        that.toggle($wrapper, $trigger, target);
    };

    UIToggle.prototype.__toggleSlideUp = function (toggle, $wrapper) {
        var that = this,
            $toggle = $(toggle),
            toggle_duration = that.duration,
            toggle_id = $toggle.data('toggle-id'),
            $trigger = $wrapper.find('[data-toggle-for="'+ toggle_id +'"]');
        
        if ($trigger.data('toggle-duration')) {
            toggle_duration = $trigger.data('toggle-duration');
        }

        if (that.isActive($toggle)) {
            $toggle.slideUp({
                duration: toggle_duration,
                start: function () {
                    $toggle.addClass(that.class.is_move);
                },
                done: function () {
                    $toggle
                        .removeClass(that.class.is_move)
                        .removeClass(that.class.is_active);
                    $trigger.removeClass(that.class.is_active);
                }
            });
        }
    };

    UIToggle.prototype.hideAll = function (wrapper, target) {
        var that = this,
            $wrapper = typeof wrapper === 'string' ? $(wrapper) : wrapper,
            $toggle = $wrapper
                        .find('.' + that.class.toggle)
                        .not('[data-toggle-id="' + target + '"]')
                        .not('.' + that.class.start_active)
                        .not('.' + that.class.start_inactive)
                        .not('.' + that.class.hide_ignore),
            
            $toggle_start_active = $wrapper.find('.' + that.class.toggle + '.' + that.class.start_active),
            $toggle_start_inactive = $wrapper.find('.' + that.class.toggle + '.' + that.class.start_inactive);

        $toggle.each(function (){
            that.__toggleSlideUp($(this), $wrapper);
        });

        $toggle_start_inactive.each(function (){
            that.__toggleSlideUp($(this), $wrapper);
        });

        $toggle_start_active.each(function (){
            var $toggle = $(this),
                toggle_duration = that.duration,
                toggle_id = $toggle.data('toggle-id'),
                $trigger = $wrapper.find('[data-toggle-for="'+ toggle_id +'"]');

            if ($trigger.data('toggle-duration')) {
                toggle_duration = $trigger.data('toggle-duration');
            }

            if (!that.isActive($toggle)) {
                $toggle.slideDown({
                    duration: toggle_duration,
                    start: function () {
                        $toggle.addClass(that.class.is_move);
                    },
                    done: function () {
                        $toggle
                            .removeClass(that.class.is_move)
                            .addClass(that.class.is_active);
                        $trigger.addClass(that.class.is_active);
                    }
                });
            }
        });
    };

    UIToggle.prototype.toggle = function ($wrapper, $trigger, target) {
        var that = this,
            $target_selector = $wrapper.find('[data-toggle-id="' + target + '"]'),
            toggle_duration = that.duration;

        if ($trigger.data('toggle-duration')) {
            toggle_duration = $trigger.data('toggle-duration');
        }
        
        $target_selector.each(function (){
            var $target_selector = $(this);

            if ($target_selector.hasClass(that.class.is_move)) {
                return;
            }
            
            $target_selector.slideToggle({
                duration: toggle_duration,
                start: function (){
                    $target_selector.toggleClass(that.class.is_move);
                },
                done: function (){
                    $target_selector
                        .toggleClass(that.class.is_move)
                        .toggleClass(that.class.is_active);
                    $trigger.toggleClass(that.class.is_active);
                }
            });
        });
    };

    UIToggle.prototype.isActive = function ($target) {
        var that = this;
        return $target.hasClass(that.class.is_active);
    };

    return UIToggle;
})($);